var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"locl-template text-center"},[_c('b-icon',{staticClass:"lock-icon-trz",attrs:{"icon":"lock-fill","aria-hidden":"true","variant":"info"}}),_vm._v(" "),_c('div',{staticClass:"lock-text"},[_vm._v("\n\t\t\tThis feature is not accesible.\n\t\t")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }